import React, { Component } from "react";
import { connect } from "react-redux";
import cookie from "react-cookies";
import { GET_WISHLIST, GET_FAVOURITE } from "../../actions";
import { apiUrl } from "../Helpers/Config";
import heart from "../../common/images/heart.svg";
import heartfill from "../../common/images/heart-fill.svg";
import actinfo1 from "../../common/images/act-info1.jpg";
import { showPriceValue } from "../Helpers/SettingHelper";
import avholder from "../../common/images/placeholder.jpg";
import axios from "axios";
import LocationIcon from "../../common/images/ttd-location-icon.svg";
import FlightIcon from "../../common/images/p_flight.svg";
import carIcon from "../../common/images/car.svg";
import bedIcon from "../../common/images/Bed.svg";
import activityIcon from "../../common/images/activity.svg";
import foodIcon from "../../common/images/Food.svg";
import flagIcon from "../../common/images/flag.svg";
import { showAlert } from "../Helpers/SettingHelper";
import "./MyAccountWishList.scss";
import TrashIcon from "../../common/images/wishlist-trash-icon.svg";
import AlertPopup from "../../common/components/AlertPopup/AlertPopup";
import ModalPopup from "../../common/components/ModalPopup/ModalPopup";
import { handleApiCall } from "../Helpers/apiHelper";
let qs = require("qs");
class MyAccountWishList extends Component {
  constructor(props) {
    super(props);
    let UserId = "";
    if (cookie.load("UserId")) {
      UserId = cookie.load("UserId");
    }
    this.state = {
      UserId: UserId,
      wishList: [],
      oldProductList: [],
      displayWishList: "",
      page: 1,
      redirected: true,
      country_List: {},
      openAlertPopup: false,
      alertPopupMsg: "",
      popupTitle: "",
      visibleWishCount: 2,
      loading: true,
      removePopup: false,
      removeItem: "",
    };
    this.removeFromWishlist = this.removeFromWishlist.bind(this);
    let params = "&customer_id=" + UserId;
    this.props.getWishList(params);
  }
  componentDidMount() {
    this.loadCity();
  }

  componentWillReceiveProps(PropsData) {
    if (PropsData.wishlist !== this.state.wishlist) {
      let oldProductList = this.state.oldProductList;
      let wishlist = PropsData.wishlist;

      if (oldProductList.length > 0) {
        oldProductList = oldProductList.concat(PropsData.wishlist);
        wishlist = oldProductList;
      }
      this.setState({
        wishlist: wishlist,
        oldProductList: wishlist,
      });
    }
    if (PropsData.wishList) {
      this.setState({
        wishList: PropsData.wishList,
        loading: false,
      });
    }
    if (this.state.addfavloading === "loading") {
      if (PropsData.favourite !== undefined) {
        this.showMessage(PropsData.favourite[0]);
      }
    }
  }

  showMessage(response) {
    this.setState({ addfavloading: "" });
    if (response.status === "ok") {
      let params = "page=1";
      if (this.state.UserId !== "") {
        params += "&customer_id=" + this.state.UserId + "&wishlist=1";
      }
      this.setState({ oldProductList: [] }, function () {
        this.props.getWishList(params);
      });
    } else {
      if (response.form_error) {
        // showAlert("Error", response.form_error);
        this.setState({
          openAlertPopup: true,
          popupTitle: "Error",
          alertPopupMsg: response.form_error,
        });
      } else {
        showAlert("Error", response.message);
        this.setState({
          openAlertPopup: true,
          popupTitle: "Error",
          alertPopupMsg: response.message,
        });
      }
      // $.magnificPopup.open({
      //   items: {
      //     src: ".alert_popup",
      //   },
      //   type: "inline",
      // });
    }
  }

  loadRatingstar(points) {
    if (points !== "" && points !== null) {
      let splitrating = points.split(".");
      return [...Array(5)].map((star, index) => {
        let currentRate = parseInt(index) + 1;
        if (parseFloat(points) >= currentRate) {
          if (
            parseInt(splitrating[0]) === parseInt(currentRate) &&
            parseInt(splitrating[1]) === 5
          ) {
            return (
              <i
                className="fa fa-star-half-o"
                aria-hidden="true"
                key={index}
              ></i>
            );
          } else {
            return (
              <i className="fa fa-star" aria-hidden="true" key={index}></i>
            );
          }
        }
      });
    }
  }

  removeFromWishlist = async (item) => {
    const formData = new FormData();
    formData.append("customer_id", cookie.load("UserId"));
    formData.append("package_unique_number", item.package_unique_number);

    try {
      const res = await handleApiCall(
        "post",
        "package/removeTripPackage",
        formData
      );

      let newState = {
        removePopup: false,
        removeItem: "",
        openAlertPopup: true,
      };

      if (res.data.status === "ok") {
        newState = {
          ...newState,
          wishList: this.state.wishList.filter(
            (wishlistItem) =>
              wishlistItem.package_unique_number !== item.package_unique_number
          ),
          popupTitle: "success",
          alertPopupMsg: "Your trip removed successfully",
        };
      } else {
        newState = {
          ...newState,
          popupTitle: "Error",
          alertPopupMsg: "Can't remove your trip!",
        };
      }

      this.setState(newState);
    } catch (error) {
      console.error(error);
      this.setState({
        removePopup: false,
        removeItem: "",
        openAlertPopup: true,
        popupTitle: "Error",
        alertPopupMsg: "Something went wrong. Please try again later.",
      });
    }
  };

  viewPackage(item) {
    let selected_City = "";
    Object.values(this.state.country_List).forEach((country) => {
      let countryDetails = Object.values(country);
      if (countryDetails[0] === item.creator_package_country) {
        countryDetails[1].map((city) => {
          if (city.city_name === item.creator_package_city) {
            selected_City = city;
          }
        });
      }
    });

    let startDate = new Date();
    let endDate = new Date(startDate);
    new Date(
      endDate.setDate(
        parseInt(endDate.getDate()) +
          (parseInt(item.creator_package_total_days) + 1)
      )
    );
    let searchdata = {
      adults: 1,
      airportLat: selected_City.airport_latitude,
      airportLon: selected_City.airport_longitude,
      checkinTime: item.hotel_check_in_time,
      child: "",
      destinationCity: selected_City.city_name,
      destinationCountry: selected_City.country_name,
      destinationLat: selected_City.airport_latitude,
      destinationLon: selected_City.airport_longitude,
      destinationWebbedsCity: selected_City.webbeds_city_code,
      destination_airport_address: selected_City.airport_address,
      destination_airport_code: selected_City.airport_code,
      destination_airport_id: selected_City.airport_id,
      destination_airport_lat: selected_City.airport_latitude,
      destination_airport_lon: selected_City.airport_longitude,
      end_date: endDate,
      images: item.creator_package_gallery,
      infant: "",
      location_destination: selected_City.airport_address,
      location_source:
        "Kempegowda International Airport Bengaluru (BLR), KIAL Rd, Devanahalli, Bengaluru, Karnataka 560300, India",
      room_count: 1,
      search_days: "2-5",
      sourceCity: "",
      sourceCountry: "India",
      sourceLat: "12.994112",
      sourceLon: "80.1708668",
      source_airport_address: "BLR",
      source_airport_code: "BLR",
      source_airport_id: "2800",
      source_airport_lat: "12.994112",
      source_airport_lon: "80.1708668",
      start_date: startDate,
      thumbnail: item.creator_package_thumbnail,
      transfer_trip_type: "Return",
      trip_type: "Return",
      total_activities: item.total_activities,
    };
    let postObject = {
      creator_id: item.creator_id,
      package_id: item.creator_package_id,
    };

    axios
      .post(apiUrl + "package/packageClick", qs.stringify(postObject), {
        headers: {
          Authorization: cookie.load("acccesstoken"),
        },
      })
      .then((res) => {
        if (res.data.status === "ok") {
          let packagedetails = {
            searchdata: searchdata,
            hotel_check_in_time: item.hotel_check_in_time,
            creator_package_total_days: item.creator_package_total_days,
          };

          this.props.history.push({
            pathname: "/search-package/" + item.creator_package_slug,
            state: packagedetails,
          });
        } else {
          console.log("ClickApi response", res.data);
        }
      });
  }

  loadCity = async () => {
    try {
      await axios
        .get(apiUrl + "settings/getCityList", {
          headers: {
            Authorization: cookie.load("acccesstoken"),
          },
        })
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({
              country_List: res.data.result_set,
            });
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  sateValChange = (field, value) => {
    if (field === "isFlight") {
      this.props.history.push({
        pathname: "/",
        state: {
          isFlight: value,
          isActivities: false,
          isVacation: false,
        },
      });
    }
    if (field === "isActivities") {
      this.props.history.push({
        pathname: "/",
        state: {
          isFlight: false,
          isActivities: value,
          isVacation: false,
        },
      });
    }
    if (field === "isVacation") {
      this.props.history.push({
        pathname: "/",
        state: {
          isFlight: false,
          isActivities: false,
          isVacation: value,
        },
      });
    }
    this.setState({ [field]: value });
  };

  handleShowRemovePopup = (item) => {
    this.setState({
      removePopup: true,
      removeItem: item,
    });
  };

  getPackageThumbNail = (item) => {
    let thumbNail = "";
    if (this.props.isMobile) {
      thumbNail = item.creator_package_thumbnail_mobile;
    } else {
      thumbNail = item.creator_package_thumbnail_web;
    }
    return thumbNail;
  };

  formatTimestamp = (timeStamp) => {
    const date = new Date(timeStamp?.replace(" ", "T"));

    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-US", options);
  };

  render() {
    const { wishList, loading } = this.state;
    return (
      <>
        <section className="wishlist-sec-cntnr">
          {!this.props.isMobile && <h2>My trips</h2>}
          <div className="wishlist-sec-cntnr__row">
            <h3>Recently added</h3>
            <ul className="wishlist-package-card-row">
              {loading ? (
                <p>Loading...</p>
              ) : wishList?.length === 0 ? (
                <p id="no-product">No products in wishlist.</p>
              ) : (
                <>
                  {wishList?.map((item, index) => {
                    return (
                      <li key={index} className="product-list-card">
                        <div className="product-thumbnail-container">
                          <img
                            src={this.getPackageThumbNail(item) || actinfo1}
                            alt="ThumbNailImg"
                            className="thumb-nail-img"
                          />
                          {this.props.isMobile && (
                            <div
                              className="trash-btn"
                              onClick={() => this.handleShowRemovePopup(item)}
                            >
                              <img src={TrashIcon} alt="TrashIcon" />
                            </div>
                            // <img
                            //   onClick={() => this.removeFromWishlist(item)}
                            //   src={
                            //     this.state.wishList.some(
                            //       (item_wish) =>
                            //         item_wish.creator_package_id ===
                            //         item.creator_package_id
                            //     )
                            //       ? heartfill
                            //       : heart
                            //   }
                            //   alt="HeartIcon"
                            //   className="like-heart-icon"
                            // />
                          )}
                          <span className="product-days">
                            {parseInt(item.creator_package_total_days)}D /{" "}
                            {item.creator_package_total_days - 1}N
                          </span>
                        </div>

                        <div className="product-detail-container">
                          <div className="product-tag-container">
                            <div className="product-tag-lhs">
                              <span className="product-tag-lhs__tags">
                                {item.creator_package_travelling}
                              </span>
                              {item.category_title && (
                                <span className="product-tag-lhs__tags">
                                  {item.category_title}
                                </span>
                              )}
                            </div>
                            <div className="product-tag-rhs">
                              {this.props.isMobile && (
                                <>
                                  <img src={LocationIcon} alt="LocationIcon" />
                                  <span>{item.creator_package_city}</span>
                                </>
                              )}
                            </div>
                          </div>

                          <h1>{item.creator_package_name}</h1>

                          <div className="product-profile-container">
                            <img
                              src={item.creator_image || avholder}
                              alt={item.creator_image}
                            />
                            <div className="product-profile-container__name">
                              <p>Created by</p>
                              <h4>{item.creator_handle_name}</h4>
                            </div>
                          </div>

                          <div className="product-included-container">
                            {item.flight_added === "Yes" && (
                              <div className="product-included-container__item">
                                <img src={FlightIcon} alt="flightIcon" />
                                Flight
                              </div>
                            )}
                            {item.transfer_added === "Yes" && (
                              <div className="product-included-container__item">
                                <img src={carIcon} alt="carIcon" />
                                Transport
                              </div>
                            )}
                            {item.stay_added === "Yes" && (
                              <div className="product-included-container__item">
                                <img src={bedIcon} alt="bedIcon" />
                                Stay
                              </div>
                            )}
                            {item.ttd_added === "Yes" && (
                              <div className="product-included-container__item">
                                <img src={activityIcon} alt="activityIcon" />
                                Activities
                              </div>
                            )}
                            {/* <div className="product-included-container__item">
                              <img src={flagIcon} alt="flagIcon" />
                              Guide
                            </div>
                            <div className="product-included-container__item">
                              <img src={foodIcon} alt="foodIcon" />
                              Food and beverage
                            </div>  */}
                          </div>
                          {item.created_at && (
                            <span className="product-created-at">
                              Saved on {this.formatTimestamp(item.created_at)}
                            </span>
                          )}
                          {/* {!this.props.isMobile && (
                            <span className="product-available-slot">
                              Next available slot : Aug 7,2024
                            </span>
                          )} */}
                        </div>

                        <div className="product-price-container">
                          {!this.props.isMobile && (
                            <>
                              {/* <img
                                onClick={() => this.removeFromWishlist(item)}
                                src={
                                  this.state.wishList.some(
                                    (item_wish) =>
                                      item_wish.creator_package_id ===
                                      item.creator_package_id
                                  )
                                    ? heartfill
                                    : heart
                                }
                                alt="HeartIcon"
                              /> */}
                              <div
                                className="trash-btn"
                                onClick={() => this.handleShowRemovePopup(item)}
                              >
                                <img src={TrashIcon} alt="TrashIcon" />
                              </div>
                            </>
                          )}

                          <div className="product-price-card">
                            {item.creator_package_source === "uop" ? (
                              <>
                                <span>Starts from</span>
                                <strong>
                                  {showPriceValue(item.creator_package_price)}
                                </strong>
                                <button>Book now</button>
                              </>
                            ) : (
                              <a href={item.share_url} target="blank">
                                {item.creator_package_source === "uop"
                                  ? "Book now"
                                  : "Customize now"}
                              </a>
                            )}
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </>
              )}
            </ul>
          </div>
        </section>
        <ModalPopup
          open={this.state.removePopup}
          handleClose={() => this.setState({ removePopup: false })}
          className="common-popup"
        >
          <div className="remove-wishlist-cntnr">
            <h3>Are you sure want to remove your trip?</h3>
            <img
              src={this.getPackageThumbNail(this.state.removeItem) || actinfo1}
              alt="packageThumbnail"
            />
            <p>{this.state.removeItem.creator_package_name}</p>
            <div className="remove-wishlist-action">
              <button
                className="btn--text"
                onClick={() => this.setState({ removePopup: false })}
              >
                cancel
              </button>
              <button
                className="btn--danger"
                onClick={() => this.removeFromWishlist(this.state.removeItem)}
              >
                Remove
              </button>
            </div>
          </div>
        </ModalPopup>
        <AlertPopup
          open={this.state.openAlertPopup}
          handleClose={() => this.setState({ openAlertPopup: false })}
          title={this.state.popupTitle}
          message={this.state.alertPopupMsg}
        />
      </>
    );
  }
}

const mapStateTopProps = (state) => {
  let wishListArr = [];
  if (state.wishlist[0]?.status === "ok") {
    if (state.wishlist.length > 0) {
      wishListArr = state.wishlist[0].result_set;
    }
  }
  return {
    wishList: wishListArr,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getWishList: (params) => {
      dispatch({ type: GET_WISHLIST, params });
    },
    getFavouritelist: (formPayload) => {
      dispatch({ type: GET_FAVOURITE, formPayload });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(MyAccountWishList);
